import {

  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import useSytle from "./Style";
import PlaceDetails from "../placeDetailes/PlaceDetiels";
import { createRef } from "react";
function List({places,childcliked,isloading , type ,setType,rating,setrating}) {
  const classes = useSytle();
  

const [elRefs, setelRefs] = useState([])
useEffect(() => {
    setelRefs((refs) => Array(places?.length).fill().map((_, i) => refs[i] || createRef()));
  }, [places]);

console.log(elRefs)
  return (
    <div className={classes.container}>
      <Typography variant="h4">
        Restaurants,Hotels & Attractions around you
      </Typography>
      {
        isloading ?(
        
        <div className={classes.loading}><CircularProgress color="primary" size="5rem"/></div>):(
        
      <>
      <FormControl className={classes.formControl}>
        <InputLabel>Type</InputLabel>
        <Select value={type} onChange={(e) => setType(e.target.value)}>
          <MenuItem value="restaurants">Restaurants</MenuItem>
          <MenuItem value="hotels">Hotels</MenuItem>
          <MenuItem value="attractions">Attractions </MenuItem>
        </Select>
      </FormControl>
      <FormControl className={classes.formControl}>
        <InputLabel>Rating</InputLabel>
        <Select value={rating} onChange={(e) => setrating(e.target.value)}>
          <MenuItem value={0}>All</MenuItem>
          <MenuItem value={3}>Above 3.0</MenuItem>
          <MenuItem value={4}>Above 4.0</MenuItem>
          <MenuItem value={4.5}>Above 4.5</MenuItem>
        </Select>
      </FormControl>

      <Grid container spacing={3} className={classes.list}>
            {places?.map((place, i) => (
               <Grid ref={elRefs[i]} key={i} item xs={12}>
                <PlaceDetails selected={Number(childcliked) === i} refProp={elRefs[i]} place={place} />
              </Grid>
            ))}
          </Grid></>) }
    </div>
  );
}

export default List;
